export const apiGetHelper = async (
  url,
  payload = { type: "GET" },
  header = {}
) => {
  try {
    let response;
    if (payload.type === "GET") {
      response = await fetch(url, {
        method: payload.type,
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
      });
    } else if (payload.type === "POST") {
      response = await fetch(url, {
        method: payload.type,
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
        body: JSON.stringify(payload.body),
      });
    }
    return response.json();
  } catch (error) {
    return error;
  }
};

export const apiPutHelper = async (
  url,
  payload = { type: "PUT" },
  header = {}
) => {
  try {
    let response = await fetch(url, {
      method: payload.type,
      headers: {
        "Content-Type": "application/json",
        ...header,
      },
      body: JSON.stringify(payload.body),
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const apiPostHelper = async (
  url,
  payload = { type: "POST" },
  header = {}
) => {
  try {
    let response = await fetch(url, {
      method: payload.type,
      headers: {
        "Content-Type": "application/json",
        ...header,
      },
      body: payload.body,
    });
    return response.json();
  } catch (error) {
    return error;
  }
};
